import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import EurosillKonfigurator from "./components/EurosillKonfigurator";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<EurosillKonfigurator />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;